<template>
	<div class="explain" :class="{'xxx':isMyList}" :style="{width:Length==1?'100%':''}">
		<div class="cover" :style="{ backgroundImage: `url(${data.image})` }">
			<img v-if="data.is_video==1" src="../assets/player-icon.png" />
		</div>

		<div class="detail w0">
		
			<div class="d-flex d-flex--justify flex--middle">
				<div class="d-flex__item w0 text-ell name pname">
					{{ data.productName }}
				</div>
			</div>
			<div class="d-flex d-flex--justify">
				<div class="d-flex__item w0 text-ell name">
					{{ data.user_name }}
				</div>
				<!-- <div class="name score">{{ data.time }}分钟</div> -->
			</div>
					<div class="d-flex ">
				<div class="time">{{ data.num }}个讲解点</div>
				<div class="time"> 讲解时长{{ data.time }}分钟</div>
				<!-- <div class="name score">{{ data.time }}分钟</div> -->
			</div>
			
			<div v-if="!brief">
				<div class="price" :class="{ raw: !data.is_buy }">
					{{ buyStatus }}
				</div>
			</div>
		</div>
		<img class="go" src="~@/assets/home/button.png" alt="" key="buy" v-if="!data.is_buy" />
		<img class="go" src="~@/assets/home/button1.png" alt="" key="ok" v-else />

	</div>
</template>

<script>
	/**
	 * 讲解块
	 */

	export const mixin = {
		computed: {
			intr() {
				try {
					return this.data.hcScenicAudioPackage.introduction;
				} catch {
					return "";
				}
			},
			buyStatus() {
				return this.data.is_buy ? "已购买" : this.data.price + "元";
			},
		},
	};

	export default {
		props: {
			brief: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
			isMyList:{
				type: Boolean,
				default: false
			},
			Length:{
				type: Number,
				default: 1
			}
		},
		mixins: [mixin],
	};
</script>

<style lang="scss">
	.price {
		font-size: 32px;
		line-height: 1;
		color: #ee2f37;
		font-weight: 600;
		&.raw {
			color: #ff6704;
			font-weight: bold;
			font-size: 34px;
			
		}
	}

	.explain+.explain {
		margin-top: 30px;
	}
	.explain.xxx{
		width: 85%;
		padding: 20px;
		border-radius: 4px;
		// border: 1px solid #0001;
		box-shadow: 0 0 12px 4px rgba($color: #555, $alpha: 0.2);
		margin-right: 30px;
		flex-shrink: 0;
		margin-top: 0;
		.go{
			right: 10px;
			bottom: 0;
		}
	}
	.explain {
		display: flex;
		position: relative;
		padding: 20px;
		box-shadow: 0 0 12px 4px rgba($color: #555, $alpha: 0.2);
		border-radius: 6px;
		.name {
			font-size: 28px;
			font-weight: 500;
			color: #444;
		}

		.pname {
			font-size: 32px;
			font-weight: 600;
			line-height: 1;
			margin-bottom: 3vw;
			color: #222;
		}

		.time {
			color: #666666;
			font-size: 24px;
			padding-right: 8px;
		}

		.status {
			font-weight: 500;
		}

		.cover {
			width: 160px;
			height: 200px;
			background: no-repeat center;
			background-size: cover;
			background-color: #ccc;
			margin-right: 20px;
			justify-content: center;
			align-items: center;
			display: flex;
			border-radius: 8px;
			display: block;
			img{
				width: 108px;
				height: 108px;	
			}
		}

		.tags {
			list-style: none;
			margin: 0;
			padding: 0;
			text-align: justify;

			li {
				display: inline-block;
				background: #efe9e3;
				color: #666666;
				border-radius: 4px;
				line-height: 1;
				padding: 4px;
				font-size: 24px;
				margin-bottom: 10px;
				margin-right: 10px;
			}
		}

		.detail {
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}

		.pos {
			color: $titlec-color;
			font-size: 32px;
			font-weight: bold;
		}

		.go {
			width: 160px;
			position: absolute;
			right: 10px;
			bottom: 0px;
			transition: transform 0.2s;
		}
	}
</style>
